import { hasFeature, type AccessFeature, type AccessLevel } from "@/features/access/access-level";

export type NavItem = {
  readonly path: string;
  readonly labelKey: string;
  readonly end?: boolean;
  /** Access-level feature required to show this entry; absent means every profile. */
  readonly feature?: AccessFeature;
};

/**
 * Top menu filtered by access level (no authentication).
 * Keep paths in sync with router public pages.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  // Shared landing page: every profile starts here. Hub is hidden for décideur.
  { path: "/", labelKey: "nav.home", end: true },
  { path: "/hub", labelKey: "nav.hub", feature: "suivi" },
];

export function navItemsForLevel(level: AccessLevel | null): readonly NavItem[] {
  return NAV_ITEMS.filter((item) => item.feature == null || hasFeature(level, item.feature));
}

/** Expected nav paths per access level. */
export const NAV_PATHS_BY_ACCESS: Readonly<Record<string, readonly string[]>> = {
  decideur: ["/"],
  analyste: ["/", "/hub"],
  scientifique: ["/", "/hub"],
};
